import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';

import { Link } from 'react-router-dom';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Author Analysis',
    description:
      'Search by authors or co-authors to see if they have a history of retractions or concerns',
  },
  {
    icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Article Analysis by DOI',
    description:
      'Check your references to avoid building on or inadvertently citing retracted works',
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Latest retractions & Portfolio Analysis',
    description:
      'Examine the latest retracted articles and follow the retraction cascades',
  },
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Interactive Dashboards',
    description:
      'See what journals are being impacted by heavy retractions',
  },
];

export default function LoginSideContent() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >
    <Typography gutterBottom sx={{ fontWeight: 'medium'}}>
    Sign in for free using your existing ORCID or Google account, or <Link to='/argos/register'>register for an Argos account</Link> to enjoy the following benefits:
    </Typography>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}